import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { ITerminalSessionTransaction } from '../../core/interfaces/ITerminalSessionTransaction';
import { TerminalsService } from '../../core/services/TerminalsService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { WorkerService } from '../../../worker/core/services/WorkerService';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';

@Component({
  selector: 'app-terminal-session-transactions-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    LoaderComponent,
    NumberToCurrencyPipe,
    LocaleDatetimeFormatPipe,
  ],
  templateUrl: './terminal-session-transactions-modal.component.html',
  styleUrl: './terminal-session-transactions-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TerminalSessionTransactionsModalComponent extends BaseModalComponent {

  public transactions: ITerminalSessionTransaction[] = [];
  public readonly selectedTransactions = new Map<number, ITerminalSessionTransaction>();
  public readonly isLoading = signal(false);

  private readonly _terminalsService = inject(TerminalsService);
  private readonly _workerService = inject(WorkerService);

  public override open(val?: null): void {
    super.open(val);
    this.loadData();
  }

  public printReceipts(): void {
    Array.from(this.selectedTransactions.keys()).forEach(id => {
      this._workerService.printReceipt(id)
        .subscribe({
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`print-receipt/notifications/${error.message}.Message`)
            );
          }
        });
    });
  }

  private loadData(): void {
    this.selectedTransactions.clear();
    this.transactions = [];
    this.isLoading.set(true);

    this._terminalsService.getTerminalSessionTransactions()
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: res => this.transactions = res.data,
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`session-transactions/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
